import { Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';
import Logo from '../../components/logo';
import './footer.css';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer__content">
                <div className="footer__info">
                    <div className="footer__logo">
                        <Logo />
                    </div>
                    <p className="footer__copyright">
                        Copyright © {new Date().getFullYear()} 3D StockPicker
                    </p>
                    <div className="footer__links">
                        <Link to="/info/termsAndConditions">
                            Terms and Conditions
                        </Link>
                        <Link to="/info/privacyPolicy">Privacy Policy</Link>
                    </div>
                </div>
                <div className="footer__contact">
                    <p className="footer__contact-title">Contact</p>
                    <div className="footer__links">
                        <a
                            className="footer__social-link"
                            href="https://www.linkedin.com/company/3d-stockpicker/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Linkedin className="sp-icon-md" />
                            <span className="footer__social-link-text">
                                3D StockPicker
                            </span>
                        </a>
                    </div>
                    <div className="footer__links">
                        <a href="mailto:info@3dstockpicker.com">
                            info@3dstockpicker.com
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
